var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1730,
    height: 1600,
    viewBox: "0 0 1730 1600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M476.603 979.511C509.27 979.511 535.752 952.905 535.752 920.085C535.752 887.264 509.27 860.658 476.603 860.658C443.935 860.658 417.453 887.264 417.453 920.085C417.453 952.905 443.935 979.511 476.603 979.511Z",
    fill: "url(#paint0_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M605.542 938.497C605.542 936.799 605.041 935.139 604.102 933.727C603.163 932.316 601.829 931.215 600.268 930.566C598.706 929.916 596.988 929.746 595.331 930.077C593.673 930.408 592.151 931.226 590.956 932.426C589.761 933.627 588.947 935.157 588.617 936.822C588.288 938.487 588.457 940.213 589.104 941.782C589.75 943.35 590.845 944.691 592.251 945.634C593.656 946.578 595.308 947.081 596.998 947.081C599.264 947.081 601.437 946.177 603.04 944.567C604.642 942.957 605.542 940.773 605.542 938.497Z",
    fill: "url(#paint1_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.394 799.108C381.394 797.41 380.893 795.75 379.954 794.339C379.015 792.927 377.68 791.827 376.119 791.177C374.558 790.527 372.84 790.357 371.182 790.688C369.525 791.02 368.002 791.837 366.807 793.038C365.612 794.238 364.799 795.768 364.469 797.433C364.139 799.098 364.308 800.825 364.955 802.393C365.602 803.962 366.697 805.302 368.102 806.246C369.507 807.189 371.159 807.693 372.849 807.693C375.115 807.693 377.289 806.788 378.891 805.178C380.494 803.568 381.394 801.385 381.394 799.108Z",
    fill: "url(#paint2_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.605 1080.12C707.605 1078.42 707.104 1076.76 706.165 1075.35C705.226 1073.94 703.891 1072.84 702.33 1072.19C700.769 1071.54 699.051 1071.37 697.393 1071.7C695.736 1072.03 694.213 1072.85 693.018 1074.05C691.823 1075.25 691.009 1076.78 690.68 1078.45C690.35 1080.11 690.519 1081.84 691.166 1083.41C691.813 1084.98 692.908 1086.32 694.313 1087.26C695.718 1088.2 697.37 1088.71 699.06 1088.71C701.326 1088.71 703.5 1087.8 705.102 1086.19C706.704 1084.58 707.605 1082.4 707.605 1080.12Z",
    fill: "url(#paint3_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.066 313.93C614.066 312.232 613.565 310.573 612.626 309.161C611.687 307.749 610.352 306.649 608.791 305.999C607.23 305.349 605.512 305.179 603.854 305.511C602.197 305.842 600.674 306.659 599.479 307.86C598.284 309.061 597.47 310.59 597.141 312.255C596.811 313.921 596.98 315.647 597.627 317.215C598.274 318.784 599.369 320.125 600.774 321.068C602.179 322.011 603.831 322.515 605.521 322.515C607.787 322.515 609.961 321.61 611.563 320C613.165 318.391 614.066 316.207 614.066 313.93Z",
    fill: "url(#paint4_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1420.05 1031.62C1420.05 1029.92 1419.54 1028.26 1418.61 1026.85C1417.67 1025.44 1416.33 1024.34 1414.77 1023.69C1413.21 1023.04 1411.49 1022.87 1409.83 1023.2C1408.18 1023.53 1406.65 1024.35 1405.46 1025.55C1404.26 1026.75 1403.45 1028.28 1403.12 1029.94C1402.79 1031.61 1402.96 1033.34 1403.61 1034.9C1404.25 1036.47 1405.35 1037.81 1406.75 1038.76C1408.16 1039.7 1409.81 1040.2 1411.5 1040.2C1413.77 1040.2 1415.94 1039.3 1417.54 1037.69C1419.15 1036.08 1420.05 1033.9 1420.05 1031.62Z",
    fill: "url(#paint5_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M240.113 1111.43C240.113 1109.73 239.611 1108.07 238.673 1106.66C237.734 1105.25 236.399 1104.15 234.838 1103.5C233.277 1102.85 231.559 1102.68 229.901 1103.01C228.244 1103.34 226.721 1104.16 225.526 1105.36C224.331 1106.56 223.517 1108.09 223.188 1109.76C222.858 1111.42 223.027 1113.15 223.674 1114.72C224.321 1116.29 225.416 1117.63 226.821 1118.57C228.226 1119.51 229.878 1120.02 231.568 1120.02C233.834 1120.02 236.007 1119.11 237.61 1117.5C239.212 1115.89 240.113 1113.71 240.113 1111.43Z",
    fill: "url(#paint6_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M411.182 933.946C486.878 857.896 486.878 734.593 411.182 658.542C335.485 582.491 212.757 582.491 137.061 658.542C61.3641 734.593 61.3641 857.896 137.061 933.946C212.757 1010 335.485 1010 411.182 933.946Z",
    fill: "url(#paint7_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M797.984 1175.65C1014.76 1175.65 1190.5 999.089 1190.5 781.294C1190.5 563.499 1014.76 386.941 797.984 386.941C581.204 386.941 405.469 563.499 405.469 781.294C405.469 999.089 581.204 1175.65 797.984 1175.65Z",
    fill: "url(#paint8_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M742.608 413.107C818.304 337.056 818.304 213.753 742.608 137.702C666.911 61.6512 544.183 61.6512 468.486 137.702C392.79 213.753 392.79 337.056 468.486 413.107C544.183 489.157 666.911 489.157 742.608 413.107Z",
    fill: "url(#paint9_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.611 693.689C168.278 693.689 194.76 667.083 194.76 634.262C194.76 601.442 168.278 574.836 135.611 574.836C102.943 574.836 76.4609 601.442 76.4609 634.262C76.4609 667.083 102.943 693.689 135.611 693.689Z",
    fill: "url(#paint10_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1670.85 742.878C1703.52 742.878 1730 716.272 1730 683.452C1730 650.632 1703.52 624.025 1670.85 624.025C1638.18 624.025 1611.7 650.632 1611.7 683.452C1611.7 716.272 1638.18 742.878 1670.85 742.878Z",
    fill: "url(#paint11_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M588.364 1111.44C621.032 1111.44 647.514 1084.83 647.514 1052.01C647.514 1019.19 621.032 992.582 588.364 992.582C555.697 992.582 529.215 1019.19 529.215 1052.01C529.215 1084.83 555.697 1111.44 588.364 1111.44Z",
    fill: "url(#paint12_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1112.92 533.761C1145.58 533.761 1172.06 507.155 1172.06 474.335C1172.06 441.514 1145.58 414.908 1112.92 414.908C1080.25 414.908 1053.77 441.514 1053.77 474.335C1053.77 507.155 1080.25 533.761 1112.92 533.761Z",
    fill: "url(#paint13_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1356.07 1097.55C1388.74 1097.55 1415.22 1070.94 1415.22 1038.12C1415.22 1005.3 1388.74 978.695 1356.07 978.695C1323.4 978.695 1296.92 1005.3 1296.92 1038.12C1296.92 1070.94 1323.4 1097.55 1356.07 1097.55Z",
    fill: "url(#paint14_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1164.93 812.562C1197.59 812.562 1224.08 785.956 1224.08 753.135C1224.08 720.315 1197.59 693.709 1164.93 693.709C1132.26 693.709 1105.78 720.315 1105.78 753.135C1105.78 785.956 1132.26 812.562 1164.93 812.562Z",
    fill: "url(#paint15_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1370.75 1042.99C1514.61 1042.99 1631.23 925.826 1631.23 781.294C1631.23 636.761 1514.61 519.594 1370.75 519.594C1226.89 519.594 1110.27 636.761 1110.27 781.294C1110.27 925.826 1226.89 1042.99 1370.75 1042.99Z",
    fill: "url(#paint16_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.531 1600C436.391 1600 553.012 1482.83 553.012 1338.3C553.012 1193.77 436.391 1076.6 292.531 1076.6C148.672 1076.6 32.0508 1193.77 32.0508 1338.3C32.0508 1482.83 148.672 1600 292.531 1600Z",
    fill: "url(#paint17_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M949.286 619.882C981.954 619.882 1008.44 593.276 1008.44 560.456C1008.44 527.635 981.954 501.029 949.286 501.029C916.619 501.029 890.137 527.635 890.137 560.456C890.137 593.276 916.619 619.882 949.286 619.882Z",
    fill: "url(#paint18_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M239.719 1176.91C294.593 1155.59 321.877 1093.62 300.659 1038.49C279.44 983.354 217.754 955.942 162.879 977.26C108.004 998.578 80.7205 1060.55 101.939 1115.68C123.158 1170.82 184.844 1198.23 239.719 1176.91Z",
    fill: "url(#paint19_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M720.592 554.683C779.426 554.683 827.121 506.765 827.121 447.655C827.121 388.545 779.426 340.627 720.592 340.627C661.757 340.627 614.062 388.545 614.062 447.655C614.062 506.765 661.757 554.683 720.592 554.683Z",
    fill: "url(#paint20_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1469.03 1365.66C1526.36 1352.37 1562.1 1294.9 1548.87 1237.3C1535.63 1179.71 1478.43 1143.8 1421.1 1157.09C1363.78 1170.39 1328.03 1227.86 1341.27 1285.45C1354.5 1343.05 1411.7 1378.96 1469.03 1365.66Z",
    fill: "url(#paint21_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M994.614 447.656C1027.28 447.656 1053.76 421.05 1053.76 388.229C1053.76 355.409 1027.28 328.803 994.614 328.803C961.947 328.803 935.465 355.409 935.465 388.229C935.465 421.05 961.947 447.656 994.614 447.656Z",
    fill: "url(#paint22_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1270.73 1253.38C1303.4 1253.38 1329.88 1226.77 1329.88 1193.95C1329.88 1161.13 1303.4 1134.53 1270.73 1134.53C1238.06 1134.53 1211.58 1161.13 1211.58 1193.95C1211.58 1226.77 1238.06 1253.38 1270.73 1253.38Z",
    fill: "url(#paint23_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1222.03 1138.09C1222.03 1136.39 1221.53 1134.73 1220.59 1133.32C1219.65 1131.91 1218.32 1130.81 1216.76 1130.16C1215.19 1129.51 1213.48 1129.34 1211.82 1129.67C1210.16 1130 1208.64 1130.82 1207.44 1132.02C1206.25 1133.22 1205.44 1134.75 1205.11 1136.41C1204.78 1138.08 1204.95 1139.8 1205.59 1141.37C1206.24 1142.94 1207.33 1144.28 1208.74 1145.23C1210.14 1146.17 1211.8 1146.67 1213.49 1146.67C1215.75 1146.67 1217.93 1145.77 1219.53 1144.16C1221.13 1142.55 1222.03 1140.37 1222.03 1138.09Z",
    fill: "url(#paint24_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M981.863 521.46C981.863 519.762 981.361 518.102 980.422 516.69C979.484 515.279 978.149 514.178 976.588 513.528C975.027 512.879 973.308 512.709 971.651 513.04C969.994 513.371 968.471 514.189 967.276 515.389C966.081 516.59 965.267 518.12 964.938 519.785C964.608 521.45 964.777 523.176 965.424 524.745C966.071 526.313 967.166 527.654 968.571 528.597C969.976 529.541 971.628 530.044 973.318 530.044C975.584 530.044 977.757 529.14 979.36 527.53C980.962 525.92 981.863 523.736 981.863 521.46Z",
    fill: "url(#paint25_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.62 1179.12C1479.62 1177.43 1479.12 1175.77 1478.18 1174.35C1477.25 1172.94 1475.91 1171.84 1474.35 1171.19C1472.79 1170.54 1471.07 1170.37 1469.41 1170.7C1467.76 1171.04 1466.23 1171.85 1465.04 1173.05C1463.84 1174.25 1463.03 1175.78 1462.7 1177.45C1462.37 1179.11 1462.54 1180.84 1463.19 1182.41C1463.83 1183.98 1464.93 1185.32 1466.33 1186.26C1467.74 1187.2 1469.39 1187.71 1471.08 1187.71C1473.35 1187.71 1475.52 1186.8 1477.12 1185.19C1478.72 1183.58 1479.62 1181.4 1479.62 1179.12Z",
    fill: "url(#paint26_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M614.066 470.145C614.066 468.447 613.565 466.787 612.626 465.376C611.687 463.964 610.352 462.864 608.791 462.214C607.23 461.564 605.512 461.394 603.854 461.726C602.197 462.057 600.674 462.874 599.479 464.075C598.284 465.275 597.47 466.805 597.141 468.47C596.811 470.136 596.98 471.862 597.627 473.43C598.274 474.999 599.369 476.34 600.774 477.283C602.179 478.226 603.831 478.73 605.521 478.73C607.787 478.73 609.961 477.825 611.563 476.215C613.165 474.605 614.066 472.422 614.066 470.145Z",
    fill: "url(#paint27_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M584.609 501.03C584.609 499.332 584.108 497.672 583.169 496.261C582.23 494.849 580.895 493.749 579.334 493.099C577.773 492.449 576.055 492.279 574.397 492.61C572.74 492.942 571.217 493.759 570.022 494.96C568.827 496.16 568.013 497.69 567.684 499.355C567.354 501.02 567.523 502.746 568.17 504.315C568.817 505.884 569.912 507.224 571.317 508.168C572.722 509.111 574.374 509.614 576.064 509.614C578.33 509.614 580.504 508.71 582.106 507.1C583.708 505.49 584.609 503.307 584.609 501.03Z",
    fill: "url(#paint28_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M437.659 860.659C437.659 858.961 437.158 857.301 436.219 855.889C435.281 854.478 433.946 853.377 432.385 852.728C430.823 852.078 429.105 851.908 427.448 852.239C425.79 852.57 424.268 853.388 423.073 854.589C421.878 855.789 421.064 857.319 420.735 858.984C420.405 860.649 420.574 862.375 421.221 863.944C421.867 865.513 422.963 866.853 424.368 867.797C425.773 868.74 427.425 869.243 429.115 869.243C431.381 869.243 433.554 868.339 435.157 866.729C436.759 865.119 437.659 862.936 437.659 860.659Z",
    fill: "url(#paint29_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1208.7 492.465C1208.7 490.768 1208.2 489.108 1207.26 487.696C1206.32 486.284 1204.99 485.184 1203.42 484.534C1201.86 483.885 1200.14 483.715 1198.49 484.046C1196.83 484.377 1195.31 485.195 1194.11 486.395C1192.92 487.596 1192.1 489.125 1191.77 490.791C1191.44 492.456 1191.61 494.182 1192.26 495.751C1192.91 497.319 1194 498.66 1195.41 499.603C1196.81 500.546 1198.46 501.05 1200.15 501.05C1202.42 501.05 1204.59 500.146 1206.2 498.536C1207.8 496.926 1208.7 494.742 1208.7 492.465Z",
    fill: "url(#paint30_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1147.93 556.724C1152.63 556.724 1156.45 552.89 1156.45 548.161C1156.45 543.431 1152.63 539.598 1147.93 539.598C1143.22 539.598 1139.4 543.431 1139.4 548.161C1139.4 552.89 1143.22 556.724 1147.93 556.724Z",
    fill: "url(#paint31_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1687.9 843.379C1687.9 841.682 1687.4 840.022 1686.46 838.61C1685.52 837.198 1684.18 836.098 1682.62 835.448C1681.06 834.799 1679.34 834.629 1677.69 834.96C1676.03 835.291 1674.51 836.109 1673.31 837.309C1672.12 838.51 1671.3 840.039 1670.97 841.705C1670.64 843.37 1670.81 845.096 1671.46 846.665C1672.11 848.233 1673.2 849.574 1674.61 850.517C1676.01 851.461 1677.66 851.964 1679.35 851.964C1681.62 851.964 1683.79 851.06 1685.4 849.45C1687 847.84 1687.9 845.656 1687.9 843.379Z",
    fill: "url(#paint32_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1030.18 843.379C1030.18 841.682 1029.68 840.022 1028.74 838.61C1027.8 837.198 1026.47 836.098 1024.9 835.448C1023.34 834.799 1021.62 834.629 1019.97 834.96C1018.31 835.291 1016.79 836.109 1015.59 837.309C1014.4 838.51 1013.58 840.039 1013.25 841.705C1012.92 843.37 1013.09 845.096 1013.74 846.665C1014.39 848.233 1015.48 849.574 1016.89 850.517C1018.29 851.461 1019.94 851.964 1021.63 851.964C1023.9 851.964 1026.07 851.06 1027.68 849.45C1029.28 847.84 1030.18 845.656 1030.18 843.379Z",
    fill: "url(#paint33_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.86 727.254C1061.86 725.557 1061.36 723.897 1060.42 722.485C1059.48 721.073 1058.15 719.973 1056.59 719.323C1055.03 718.674 1053.31 718.504 1051.65 718.835C1049.99 719.166 1048.47 719.984 1047.28 721.184C1046.08 722.385 1045.27 723.914 1044.94 725.58C1044.61 727.245 1044.78 728.971 1045.42 730.54C1046.07 732.108 1047.17 733.449 1048.57 734.392C1049.98 735.336 1051.63 735.839 1053.32 735.839C1055.58 735.839 1057.76 734.935 1059.36 733.325C1060.96 731.715 1061.86 729.531 1061.86 727.254Z",
    fill: "url(#paint34_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.359 1237.15C544.359 1235.46 543.858 1233.8 542.919 1232.38C541.98 1230.97 540.645 1229.87 539.084 1229.22C537.523 1228.57 535.805 1228.4 534.147 1228.73C532.49 1229.07 530.967 1229.88 529.772 1231.08C528.577 1232.28 527.763 1233.81 527.434 1235.48C527.104 1237.14 527.273 1238.87 527.92 1240.44C528.567 1242.01 529.662 1243.35 531.067 1244.29C532.472 1245.23 534.124 1245.74 535.814 1245.74C538.08 1245.74 540.254 1244.83 541.856 1243.22C543.458 1241.61 544.359 1239.43 544.359 1237.15Z",
    fill: "url(#paint35_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 742.897C1128.74 741.199 1128.24 739.539 1127.3 738.128C1126.36 736.716 1125.03 735.616 1123.47 734.966C1121.91 734.316 1120.19 734.146 1118.53 734.477C1116.87 734.809 1115.35 735.626 1114.16 736.827C1112.96 738.027 1112.15 739.557 1111.82 741.222C1111.49 742.888 1111.66 744.614 1112.3 746.182C1112.95 747.751 1114.04 749.092 1115.45 750.035C1116.85 750.978 1118.51 751.482 1120.2 751.482C1122.46 751.482 1124.64 750.577 1126.24 748.967C1127.84 747.357 1128.74 745.174 1128.74 742.897Z",
    fill: "url(#paint36_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1658.5 899.075C1658.5 897.377 1658 895.717 1657.06 894.305C1656.12 892.894 1654.79 891.793 1653.23 891.144C1651.67 890.494 1649.95 890.324 1648.29 890.655C1646.63 890.986 1645.11 891.804 1643.92 893.005C1642.72 894.205 1641.91 895.735 1641.58 897.4C1641.25 899.065 1641.42 900.791 1642.06 902.36C1642.71 903.929 1643.81 905.269 1645.21 906.213C1646.62 907.156 1648.27 907.659 1649.96 907.659C1652.22 907.659 1654.4 906.755 1656 905.145C1657.6 903.535 1658.5 901.352 1658.5 899.075Z",
    fill: "url(#paint37_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1479.62 574.836C1479.62 573.139 1479.12 571.479 1478.18 570.067C1477.25 568.655 1475.91 567.555 1474.35 566.905C1472.79 566.256 1471.07 566.086 1469.41 566.417C1467.76 566.748 1466.23 567.566 1465.04 568.766C1463.84 569.967 1463.03 571.497 1462.7 573.162C1462.37 574.827 1462.54 576.553 1463.19 578.122C1463.83 579.69 1464.93 581.031 1466.33 581.974C1467.74 582.918 1469.39 583.421 1471.08 583.421C1473.35 583.421 1475.52 582.517 1477.12 580.907C1478.72 579.297 1479.62 577.113 1479.62 574.836Z",
    fill: "url(#paint38_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1105.69 1131.37C1105.69 1129.68 1105.19 1128.02 1104.25 1126.6C1103.32 1125.19 1101.98 1124.09 1100.42 1123.44C1098.86 1122.79 1097.14 1122.62 1095.48 1122.95C1093.83 1123.29 1092.3 1124.1 1091.11 1125.3C1089.91 1126.5 1089.1 1128.03 1088.77 1129.7C1088.44 1131.36 1088.61 1133.09 1089.26 1134.66C1089.9 1136.23 1091 1137.57 1092.4 1138.51C1093.81 1139.45 1095.46 1139.96 1097.15 1139.96C1099.42 1139.96 1101.59 1139.05 1103.19 1137.44C1104.79 1135.83 1105.69 1133.65 1105.69 1131.37Z",
    fill: "url(#paint39_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1013.97 548.161C1013.97 546.463 1013.47 544.803 1012.53 543.391C1011.59 541.98 1010.25 540.879 1008.69 540.23C1007.13 539.58 1005.41 539.41 1003.76 539.741C1002.1 540.072 1000.58 540.89 999.382 542.091C998.187 543.291 997.373 544.821 997.043 546.486C996.713 548.151 996.883 549.877 997.529 551.446C998.176 553.015 999.271 554.355 1000.68 555.299C1002.08 556.242 1003.73 556.745 1005.42 556.745C1007.69 556.745 1009.86 555.841 1011.47 554.231C1013.07 552.621 1013.97 550.437 1013.97 548.161Z",
    fill: "url(#paint40_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M457.507 447.657C457.507 445.959 457.006 444.299 456.067 442.887C455.128 441.476 453.794 440.375 452.232 439.726C450.671 439.076 448.953 438.906 447.296 439.237C445.638 439.568 444.116 440.386 442.921 441.587C441.726 442.787 440.912 444.317 440.582 445.982C440.252 447.647 440.422 449.373 441.068 450.942C441.715 452.511 442.81 453.851 444.215 454.795C445.621 455.738 447.273 456.241 448.963 456.241C451.229 456.241 453.402 455.337 455.004 453.727C456.607 452.117 457.507 449.934 457.507 447.657Z",
    fill: "url(#paint41_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M672.999 742.897C672.999 741.199 672.498 739.539 671.559 738.128C670.62 736.716 669.286 735.616 667.725 734.966C666.163 734.316 664.445 734.146 662.788 734.477C661.13 734.809 659.608 735.626 658.413 736.827C657.218 738.027 656.404 739.557 656.074 741.222C655.745 742.888 655.914 744.614 656.561 746.182C657.207 747.751 658.302 749.092 659.708 750.035C661.113 750.978 662.765 751.482 664.455 751.482C666.721 751.482 668.894 750.577 670.497 748.967C672.099 747.357 672.999 745.174 672.999 742.897Z",
    fill: "url(#paint42_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M406.495 899.075C406.495 897.377 405.994 895.717 405.055 894.305C404.116 892.894 402.782 891.793 401.221 891.144C399.659 890.494 397.941 890.324 396.284 890.655C394.626 890.986 393.104 891.804 391.909 893.005C390.714 894.205 389.9 895.735 389.57 897.4C389.241 899.065 389.41 900.791 390.057 902.36C390.703 903.929 391.799 905.269 393.204 906.213C394.609 907.156 396.261 907.659 397.951 907.659C400.217 907.659 402.39 906.755 403.993 905.145C405.595 903.535 406.495 901.352 406.495 899.075Z",
    fill: "url(#paint43_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M144.136 742.897C144.136 741.199 143.635 739.539 142.696 738.128C141.757 736.716 140.423 735.616 138.861 734.966C137.3 734.316 135.582 734.146 133.924 734.477C132.267 734.809 130.744 735.626 129.55 736.827C128.355 738.027 127.541 739.557 127.211 741.222C126.881 742.888 127.051 744.614 127.697 746.182C128.344 747.751 129.439 749.092 130.844 750.035C132.249 750.978 133.901 751.482 135.591 751.482C137.858 751.482 140.031 750.577 141.633 748.967C143.236 747.357 144.136 745.174 144.136 742.897Z",
    fill: "url(#paint44_radial_336_54)",
    style: {
      mixBlendMode: "screen"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(476.603 920.085) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(597.04 938.497) scale(7.96779 8.00507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.871 799.108) scale(7.9678 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(699.082 1080.12) scale(7.9678 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(605.542 313.93) scale(7.96779 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1411.52 1031.62) scale(7.96779 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.589 1111.43) scale(7.96779 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(274.128 796.242) scale(181.465 182.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(797.984 781.294) scale(366.753 368.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(605.54 275.394) scale(181.465 182.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.611 634.262) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1670.85 683.452) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588.364 1052.01) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1112.92 474.335) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1356.07 1038.12) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1164.93 753.135) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1370.75 781.294) scale(243.883 245.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(292.531 1338.3) scale(243.883 245.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(949.286 560.456) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.249 1077.1) scale(99.7362 100.203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720.592 447.655) scale(99.7362 100.203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1445.06 1261.4) scale(99.7362 100.203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(994.614 388.229) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1270.73 1193.95) scale(55.39 55.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1213.53 1138.09) scale(7.96779 8.00507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(973.339 521.46) scale(7.96778 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1471.1 1179.12) scale(7.96781 8.00507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(605.542 470.145) scale(7.96779 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(576.085 501.03) scale(7.96779 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.136 860.659) scale(7.96779 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1200.22 492.465) scale(7.96778 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1147.93 548.161) scale(7.9678 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1679.37 843.379) scale(7.96781 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1021.66 843.379) scale(7.96777 8.0051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1053.34 727.254) scale(7.9678 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(535.75 1237.15) scale(7.96779 8.00508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1120.22 742.897) scale(7.9678 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1650 899.075) scale(7.96779 8.00508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1471.1 574.837) scale(7.96781 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1097.17 1131.37) scale(7.96778 8.00507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1005.44 548.161) scale(7.96778 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(448.984 447.657) scale(7.96779 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(664.476 742.897) scale(7.9678 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397.994 899.075) scale(7.96779 8.00508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_336_54",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.613 742.897) scale(7.96779 8.00509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB069",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewbg);
export default __webpack_public_path__ + "static/media/overviewbg.feccd3650ab1ea9e96687171e575850c.svg";
export { ForwardRef as ReactComponent };